import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "../components/motion";

export default function PaymentCancel() {
  return (
    <section className="pt-[72px] hero-grid-bg min-h-screen flex items-center" data-testid="payment-cancel-page">
      <div className="max-w-xl mx-auto px-5 sm:px-8 py-24 text-center w-full">
        <Reveal>
          <div className="bg-white rounded-[2rem] border border-ink/5 shadow-[0_24px_64px_rgba(20,22,46,0.1)] p-10 sm:p-14">
            <h1 className="font-display font-bold text-2xl sm:text-3xl text-ink mb-3">Payment cancelled.</h1>
            <p className="text-slate text-sm leading-relaxed mb-8">
              No charge was made. You can restart the payment whenever you're ready.
            </p>
            <Link to="/pay" data-testid="cancel-back-to-pay-link" className="inline-flex items-center gap-2 bg-indigo text-white font-semibold px-7 py-3 rounded-full hover:bg-ink transition-colors duration-300 text-sm">
              <ArrowLeft className="w-4 h-4" /> Back to payment
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
